import { z } from 'zod';
import { cn } from '@/shared/lib/cn';

/**
 * Passwortregeln wie der Server, als frühe Haken unter dem Feld: `StrongPassword` und dazu der
 * Kleinbuchstabe, den Identity von sich aus verlangt (`RequireLowercase`, nur a–z). Der Server
 * bleibt final.
 */
export const PASSWORD_RULES: { label: string; test: (value: string) => boolean }[] = [
  { label: 'Mindestens 12 Zeichen', test: (value) => value.length >= 12 },
  { label: 'Eine Ziffer', test: (value) => /\d/.test(value) },
  { label: 'Ein Großbuchstabe', test: (value) => /[A-Z]/.test(value) },
  { label: 'Ein Kleinbuchstabe', test: (value) => /[a-z]/.test(value) },
  { label: 'Ein Sonderzeichen', test: (value) => /[^a-zA-Z0-9]/.test(value) },
];

export const newPasswordSchema = z
  .object({
    password: z
      .string()
      .refine(
        (value) => PASSWORD_RULES.every((rule) => rule.test(value)),
        'Das Passwort erfüllt noch nicht alle Regeln.',
      ),
    confirm: z.string(),
  })
  .refine((v) => v.password === v.confirm, {
    path: ['confirm'],
    message: 'Die beiden Passwörter stimmen nicht überein.',
  });

export type NewPasswordValues = z.infer<typeof newPasswordSchema>;

/** Die Regeln als Haken: erfüllt in Wald, offen in Tinte mit „fehlt noch“. */
export function PasswordRuleList({ value }: { value: string }) {
  return (
    <ul aria-label="Passwortregeln" className="flex flex-col gap-1">
      {PASSWORD_RULES.map((rule) => {
        const ok = rule.test(value);
        return (
          <li
            key={rule.label}
            className={cn('text-[13px]', ok ? 'text-forest font-semibold' : 'text-ink font-bold')}
          >
            {ok ? '✓ ' : '– '}
            {rule.label}
            {!ok && value.length > 0 && ' – fehlt noch'}
          </li>
        );
      })}
    </ul>
  );
}
